export default __webpack_public_path__ + "static/media/grayEllipse.5a940f09.svg";